var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c("div", { staticClass: "card setting-card" }, [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("accounts.company_address"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.name"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount &&
          _vm.viewAccount.company_address &&
          _vm.viewAccount.company_address.name != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.company_address.name))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.country"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount &&
          _vm.viewAccount.company_address &&
          _vm.viewAccount.company_address.country != null
            ? _c("p", [
                _vm._v(_vm._s(_vm.viewAccount.company_address.country.name)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.state"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount &&
          _vm.viewAccount.company_address &&
          _vm.viewAccount.company_address.state != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.company_address.state))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.city"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount &&
          _vm.viewAccount.company_address &&
          _vm.viewAccount.company_address.city != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.company_address.city))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("general.street_1"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount &&
          _vm.viewAccount.company_address &&
          _vm.viewAccount.company_address.address_street_1 != null
            ? _c("p", [
                _vm._v(
                  _vm._s(_vm.viewAccount.company_address.address_street_1)
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("general.street_2"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount &&
          _vm.viewAccount.company_address &&
          _vm.viewAccount.company_address.address_street_2 != null
            ? _c("p", [
                _vm._v(
                  _vm._s(_vm.viewAccount.company_address.address_street_2)
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.phone"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount &&
          _vm.viewAccount.company_address &&
          _vm.viewAccount.company_address.phone != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.company_address.phone))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("accounts.zip_code"))),
          ]),
          _vm._v(" "),
          _vm.viewAccount &&
          _vm.viewAccount.company_address &&
          _vm.viewAccount.company_address.zip != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewAccount.company_address.zip))])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }